import React from 'react';
import { translations } from '../utils/translations';

// Helper to generate stable keys from content
const getStableKey = (content, prefix = '') => {
  return `${prefix}-${content.substring(0, 20).replace(/\s+/g, '-')}`;
};

const Terms = ({ language = 'en' }) => {
  const t = translations[language].terms;

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="section-container">
          <h1>{t.title}</h1>
          <p className="legal-date">{t.lastUpdated}</p>
        </div>
      </div>

      <div className="legal-content">
        <div className="section-container narrow">
          <section className="legal-section">
            <h2>{t.section1Title}</h2>
            <p>{t.section1Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section2Title}</h2>
            <p>
              {t.section2Content.split('|').map((line) => (
                <React.Fragment key={getStableKey(line, 'section2')}>
                  {line !== t.section2Content.split('|')[0] && <br />}
                  {line.includes('CIF') ? <strong>{line}</strong> : line}
                </React.Fragment>
              ))}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t.section3Title}</h2>
            <p>{t.section3Intro}</p>
            <ul>
              {t.section3Items.split('|').map((item) => (
                <li key={getStableKey(item, 'section3')}>{item}</li>
              ))}
            </ul>
            <p>{t.section3Footer}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section4Title}</h2>
            <p>{t.section4Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section5Title}</h2>
            <p>{t.section5Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section6Title}</h2>
            <p>{t.section6Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section7Title}</h2>
            <p>{t.section7Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section8Title}</h2>
            <p>{t.section8Intro}</p>
            <ul>
              {t.section8Items.split('|').map((item) => (
                <li key={getStableKey(item, 'section8')}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.section9Title}</h2>
            <p>{t.section9Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section10Title}</h2>
            <p>{t.section10Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section11Title}</h2>
            <p>{t.section11Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section12Title}</h2>
            <p>{t.section12Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section13Title}</h2>
            <p>{t.section13Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section14Title}</h2>
            <p>{t.section14Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section15Title}</h2>
            <p>{t.section15Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section16Title}</h2>
            <p>{t.section16Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section17Title}</h2>
            <p>{t.section17Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section18Title}</h2>
            <p>
              {t.section18Content.split('|').map((line) => (
                <React.Fragment key={getStableKey(line, 'section18')}>
                  {line !== t.section18Content.split('|')[0] && <br />}
                  {line}
                </React.Fragment>
              ))}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
